import { render, staticRenderFns } from "./PaymentTimeoutModalComponent.vue?vue&type=template&id=bdc19d44&"
import script from "./PaymentTimeoutModalComponent.vue?vue&type=script&lang=ts&"
export * from "./PaymentTimeoutModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports